import { IEnvironment } from './environment';

export const environmentProd: IEnvironment = {
    environments: [
        {
            name: 'Mainnet',
            url: 'https://api-p2p.ergoplatform.com',
        },
    ],
    isLoggerEnabled: false,
};
